<template>
  <div class ="rfiles">
    <f7-link @click="downloadZipFromPreview" v-if="form.formData.documentos && form.formData.documentos.length > 1">
      <f7-icon f7="archivebox"></f7-icon>
      Descargar como zip
    </f7-link>
    <!-- <div class="rfiles-container margin-horizontal"> -->
    <div v-if="preview && showOrigenAgrupadoMode()" class="rfiles-origin-wrapper">
      <div class="rfiles-origin-section">
        <!-- <div class="rfiles-origin-title" v-if="getOwnDocsWithIndexes().length">Documentos del origen actual</div> -->
        <div class="rfiles-container">
          <div class="rfiles-item" v-for="docObj in getOwnDocsWithIndexes()" :key="'own-file-'+prefixKey+'-'+docObj.index">
            <span :contenteditable="false" class="rfiles-close" v-if="!readonly&&!form.readonly" @click="deleteItem(docObj.index)">
              <f7-icon v-tooltip="'Eliminar'" f7="multiply_circle_fill" />
            </span>
            <r-badge :contenteditable="false" class="rfiles-badge" color="green" :text="(docObj.index + 1)+''"></r-badge>
            <f7-checkbox
              v-if="mostrarCheck(docObj.item)"
              :class="{ 'disabled': readonly || form.readonly }"
              class="rfiles-check"
              :checked="docObj.item.selected"
              @change="onChangeCheck(docObj.item, $event.target.checked)"
            ></f7-checkbox>
            <a
              v-if="target === 'cordova' && !ignorarOffline"
              @paste.prevent="paste"
              :contenteditable="false"
              @input.prevent="false"
              @mousedown.prevent="_ => {return false}"
              :class="{base64: !!docObj.item._base64}"
              :data-name="docObj.item.nombre + '.' + docObj.item.extension"
              @click.stop="see(docObj.item)"
            >
              <img :alt="docObj.item.nombre" :style="'height:' + itemHeight + 'px;'" :data-name="docObj.item.nombre + '.' + docObj.item.extension" v-tooltip="docObj.item.nombre" :src="getSrc(docObj.item)"/>
            </a>
            <a v-else :contenteditable="false" @paste.prevent="paste" @input.prevent="false" @mousedown.prevent="_ => {return false}">
              <img
                :alt="docObj.item.nombre"
                :style="'height:' + itemHeight + 'px;'"
                :data-name="docObj.item.nombre + '.' + docObj.item.extension"
                v-tooltip="docObj.item.nombre" :src="getSrc(docObj.item)"
                @click="previewDocument(docObj.item, docObj.index)" />
            </a>
          </div>
        </div>
      </div>
      <fieldset class="rfiles-origin-fieldset" v-for="group in getForeignDocGroups()" :key="'foreign-group-'+prefixKey+'-'+group.key">
        <legend>
          Documentos de otro origen
          <span class="badge" v-if="group.label">{{ group.label }}</span>
        </legend>
        <div class="rfiles-container">
          <div class="rfiles-item" v-for="docObj in group.docs" :key="'foreign-file-'+prefixKey+'-'+docObj.index">
            <span :contenteditable="false" class="rfiles-close" v-if="!readonly&&!form.readonly" @click="deleteItem(docObj.index)">
              <f7-icon v-tooltip="'Eliminar'" f7="multiply_circle_fill" />
            </span>
            <r-badge :contenteditable="false" class="rfiles-badge" color="orange" :text="(docObj.index + 1)+''"></r-badge>
            <f7-checkbox
              v-if="mostrarCheck(docObj.item)"
              :class="{ 'disabled': readonly || form.readonly }"
              class="rfiles-check"
              :checked="docObj.item.selected"
              @change="onChangeCheck(docObj.item, $event.target.checked)"
            ></f7-checkbox>
            <a
              v-if="target === 'cordova' && !ignorarOffline"
              @paste.prevent="paste"
              :contenteditable="false"
              @input.prevent="false"
              @mousedown.prevent="_ => {return false}"
              :class="{base64: !!docObj.item._base64}"
              :data-name="docObj.item.nombre + '.' + docObj.item.extension"
              @click.stop="see(docObj.item)"
            >
              <img :alt="docObj.item.nombre" :style="'height:' + itemHeight + 'px;'" :data-name="docObj.item.nombre + '.' + docObj.item.extension" v-tooltip="docObj.item.nombre" :src="getSrc(docObj.item)"/>
            </a>
            <a v-else :contenteditable="false" @paste.prevent="paste" @input.prevent="false" @mousedown.prevent="_ => {return false}">
              <img
                :alt="docObj.item.nombre"
                :style="'height:' + itemHeight + 'px;'"
                :data-name="docObj.item.nombre + '.' + docObj.item.extension"
                v-tooltip="docObj.item.nombre" :src="getSrc(docObj.item)"
                @click="previewDocument(docObj.item, docObj.index)" />
            </a>
          </div>
        </div>
      </fieldset>
    </div>
    <div v-else-if="preview" @drop.prevent="onDropOut" :dropZoneActive="activeDrag && !readonly && !form.readonly" :data-active="activeDrag" @dragenter.prevent="activeDrag = true" @dragover.prevent="activeDrag = true" @dragleave.prevent="activeDrag = false">
    <Container
        group-name="group-files"
        orientation="horizontal"
        :contenteditable="!readonly && !form.readonly"
        class="rfiles-container"
        :class="{'dashed': !readonly&&!form.readonly}"
        :animation-duration="1000"
        @drop="onDrop(getValue(), $event)"
        :get-child-payload="getPayload(getValue())"
        :should-accept-drop="(src, payload) => getShouldAcceptDrop(getValue(), src, payload)"
        drag-handle-selector=".column-drag-handle"
      >
        
        <a v-if="!getValue() || !getValue().length" :contenteditable="false" @paste.prevent="paste" @input.prevent="false" @mousedown.prevent="_ => {return false}">
        </a>
        <Draggable class="rfiles-item" v-for="(item,iaf) in getValue()" :key="'file-'+prefixKey+'-'+iaf">
          <span :contenteditable="false" class="rfiles-close" v-if="!readonly&&!form.readonly" @click="deleteItem(iaf)">
            <f7-icon v-tooltip="'Eliminar'" f7="multiply_circle_fill" />
          </span>
          <r-badge :contenteditable="false" class="rfiles-badge" color="green" :text="(iaf + 1)+''"></r-badge>
          <f7-checkbox 
            v-if="mostrarCheck(item)"
            :class="{ 'disabled': readonly || form.readonly }"
            class="rfiles-check"
            :checked="item.selected"
            @change="onChangeCheck(item, $event.target.checked)"
          ></f7-checkbox>
          <a
            v-if="target === 'cordova' && !ignorarOffline"
            @paste.prevent="paste"
            :contenteditable="false"
            @input.prevent="false"
            @mousedown.prevent="_ => {return false}"
            :class="{base64: !!item._base64}"
            :data-name="item.nombre + '.' + item.extension"
            @click.stop="see(item)"
          >
            <img :class="{'column-drag-handle': !readonly&&!form.readonly}" :alt="item.nombre" :style="'height:' + itemHeight + 'px;'" :data-name="item.nombre + '.' + item.extension" v-tooltip="item.nombre" :src="getSrc(item)"/>
          </a>
          <a v-else :contenteditable="false" @paste.prevent="paste" @input.prevent="false" @mousedown.prevent="_ => {return false}">
            <img
              :alt="item.nombre" 
              :class="{'column-drag-handle': !readonly&&!form.readonly}"
              :style="'height:' + itemHeight + 'px;'"
              :data-name="item.nombre + '.' + item.extension"
              v-tooltip="item.nombre" :src="getSrc(item)"
              @click="previewDocument(item, iaf)" />
          </a>
          <!-- vamos a poner un  r-input tipo textarea para los comentarios de los ficheros -->
          <r-input 
            v-if="mostrarComentario"
            :form="form"
            :contenteditable="false"
            class="comentario-rfile"
            outline
            style="width: 100%;"
            floating-label
            :label="'Comentario'" 
            type="textarea"
            :name="name + '.' + iaf + '.comentario'" 
          />
        </Draggable>
      </Container>
    </div>
    <div>
      <slot name="add" v-if="!readonly&&!form.readonly&&(!maxFiles||!getValue()||getValue().length<maxFiles)">
        <input :multiple="!maxFiles || maxFiles > 1" type="file" ref="input" style="display:none;" @change="loadFile" />
        <f7-block class="rfiles-add">
          <f7-button @click="$refs.input.click()">{{label}}</f7-button>
          <!-- En la APK, un formulario online (ignorarOffline) puede hacer la foto con la cámara del
               dispositivo: sale como _base64, igual que un fichero elegido en la web. -->
          <f7-button v-if="target === 'cordova' && ignorarOffline && hayCamara" icon-f7="camera_fill" @click="hacerFoto">{{ labelFoto }}</f7-button>
        </f7-block>
      </slot>
    </div>
    
    <!-- Modal de previsualización -->
    <!-- Sin backdrop y arrastrable por la barra: la previsualización de un documento no tapa el
         formulario de debajo (p. ej. para cotejar un ticket con los datos que leyó la IA) y se
         puede apartar. Se cierra con «Cerrar» o con Escape (sin backdrop no hay «pulsar fuera»). -->
    <f7-popup
      ref="previewPopup"
      v-arrastrable
      :opened="previewModalVisible"
      @popup:closed="closePreview"
      class="rfiles-preview-popup"
      :backdrop="false"
      :close-by-backdrop-click="false"
      :close-on-escape="true"
    >
      <f7-page>
        <f7-navbar>
          <f7-nav-left>
            <f7-link @click="downloadFromPreview">Descargar</f7-link>
          </f7-nav-left>
          <f7-nav-title>{{ previewItem ? previewItem.nombre + '.' + previewItem.extension : '' }}</f7-nav-title>
          <f7-nav-right>
            <!-- Sin backdrop no hay «pulsar fuera» y en una pantalla táctil no hay Escape: este
                 enlace es la única forma segura de cerrar. -->
            <f7-link @click="closePreview">Cerrar</f7-link>
          </f7-nav-right>
        </f7-navbar>
        
        <f7-block class="rfiles-preview-content">
          <!-- Flecha anterior -->
          <div 
            class="rfiles-preview-nav rfiles-preview-nav-prev" 
            @click="prevDocument"
            v-if="canGoPrev"
          >
            <f7-icon f7="chevron_left_circle_fill" />
          </div>
          
          <!-- Contenido HTML para imágenes y otros tipos -->
          <div class="rfiles-preview-doc" v-html="previewHtml"></div>
          
          <!-- Flecha siguiente -->
          <div 
            class="rfiles-preview-nav rfiles-preview-nav-next" 
            @click="nextDocument"
            v-if="canGoNext"
          >
            <f7-icon f7="chevron_right_circle_fill" />
          </div>
          
          <!-- Indicador de posición -->
          <div class="rfiles-preview-counter" v-if="getValue() && getValue().length > 1">
            {{ previewIndex + 1 }} / {{ getValue().length }}
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>
  </div>
</template>
<script>

import moment from 'moment';
import FileUtils from './../js/FileUtils';
import zoomImagen from './../js/utils/zoomImagen.js';
import { Container, Draggable } from "vue-smooth-dnd";
import { capturarFotoBase64, hayCamara } from "../js/CapturaFoto.js";
import RInput from './rInput.vue';
import RBadge from './rBadge.vue';

const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;
  //const result = [...arr];
  if (!arr) arr = [];
  var result = arr;

  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = Object.assign({},  result.splice(removedIndex, 1)[0]);
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, Object.assign({}, itemToAdd));
  }

};

export default {
  components: {
    Container,
    Draggable,
    RInput,
    RBadge
  },
  data() {
    return {
      self: this,
      target: process.env.TARGET,
      hayCamara: hayCamara(),
      activeDrag: true,
      loadingThumbnails: false,
      // Propiedades para el modal de previsualización
      previewModalVisible: false,
      previewItem: null,
      previewIndex: -1,
      previewHtml: '',
      isLoadingPreview: false
    };
  },
  props: {
    name: {
      required: true,
      type: String
    },
    form: {
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    prefixKey: {
      default: ''
    },
    label: {
      default: 'Añadir documento'
    },
    labelFoto: {
      default: 'Hacer foto'
    },
    maxFiles: {
      type: Number,
      default: undefined
    },
    documentoAdapter: {
      type: Object
    },
    ignorarOffline: {
      type: Boolean,
      default: false
    },
    itemHeight: {
      type: Number,
      default: 100
    },
    mostrarComentario: {
      type: Boolean,
      default: true
    },
    mostrarCheck: {
      type: Function,
      default: function() { return false; }
    },
    mostrarAgrupadorDocumento: {
      type: Function,
      default: function() { return true; }
    },
    preview: {
      type: Boolean,
      default: true
    },
    conservarNombre: {
      type: Boolean,
      default: true
    },
    sobrescribir: {
      type: Boolean,
      default: true
    },
    // ruta donde poner los ficheros en el servidor
    path: {
      type: String,
      default: ""
    },
    offlineRootDir: {
      type: String,
      default: "Documents/"
    },
    offlinePath: {
      type: String,
      default: ""
    }
  },
  computed: {
    canGoPrev() {
      return this.previewIndex > 0;
    },
    canGoNext() {
      const value = this.getValue();
      return value && this.previewIndex < value.length - 1;
    }
  },
  methods: {
    // Navegar al documento anterior
    prevDocument() {
      var self = this;
      if (!self.canGoPrev) return;
      
      const value = self.getValue();
      if (value && self.previewIndex > 0) {
        const newIndex = self.previewIndex - 1;
        self.previewDocument(value[newIndex], newIndex);
      }
    },
    
    // Navegar al documento siguiente
    nextDocument() {
      var self = this;
      if (!self.canGoNext) return;
      
      const value = self.getValue();
      if (value && self.previewIndex < value.length - 1) {
        const newIndex = self.previewIndex + 1;
        self.previewDocument(value[newIndex], newIndex);
      }
    },
    onChangeCheck(item, value) {
      var self = this;
      item.selected = !!value;
    },
    showOrigenAgrupadoMode() {
      const self = this;
      return self.getForeignDocGroups().length > 0;
    },
    getDocumentosWithIndexes() {
      const self = this;
      const docs = self.getValue() || [];
      return docs.map((item, index) => ({ item, index }));
    },
    getDocCampo(item, key) {
      if (!item || !item.camposPersonalizados) return null;
      return item.camposPersonalizados[key];
    },
    isDocumentoDeOtroExpediente(item) {
      const self = this;
      const originId = self.getDocCampo(item, 'agrupadorId');
      const originCodigo = self.getDocCampo(item, 'agrupadorLabel');
      const hasAgrupador = !!(originId || originCodigo);
      if (!hasAgrupador) return false;
      return !!self.mostrarAgrupadorDocumento(item);
    },
    getOwnDocsWithIndexes() {
      const self = this;
      return self.getDocumentosWithIndexes().filter(d => !self.isDocumentoDeOtroExpediente(d.item));
    },
    getForeignDocsWithIndexes() {
      const self = this;
      return self.getDocumentosWithIndexes().filter(d => self.isDocumentoDeOtroExpediente(d.item));
    },
    getDocAgrupadorKey(item) {
      const self = this;
      const originId = self.getDocCampo(item, 'agrupadorId');
      const originCodigo = self.getDocCampo(item, 'agrupadorLabel');
      return String(originId || originCodigo || '');
    },
    getDocAgrupadorLabel(item) {
      const self = this;
      return String(self.getDocCampo(item, 'agrupadorLabel') || self.getDocCampo(item, 'agrupadorId') || '');
    },
    getForeignDocGroups() {
      const self = this;
      const groupsMap = {};
      const orderedKeys = [];
      self.getForeignDocsWithIndexes().forEach(docObj => {
        const key = self.getDocAgrupadorKey(docObj.item);
        if (!key) return;
        if (!groupsMap[key]) {
          groupsMap[key] = {
            key,
            label: self.getDocAgrupadorLabel(docObj.item),
            docs: []
          };
          orderedKeys.push(key);
        }
        groupsMap[key].docs.push(docObj);
      });
      return orderedKeys.map(k => groupsMap[k]);
    },
    getForeignOrigenCodigo() {
      const self = this;
      const first = self.getForeignDocsWithIndexes()[0];
      if (!first) return '';
      return self.getDocCampo(first.item, 'agrupadorLabel') || '';
    },
    paste(event) {
      const self = this;
      if (event.clipboardData.files && event.clipboardData.files.length) {
        if (!self.readonly && !self.form.readonly) {
          self.loadFile(event.clipboardData.files);
        }
      }
    },
    getPayload(arr) { 
      console.log("getPayload");
      console.log(arr);
      return index => Object.assign({}, arr[index]);
    },
    getShouldAcceptDrop (arr, src, payload) {
      console.log("getShouldAcceptDrop");
      var self = this;
      // return src.groupName == 'group-count' || src.groupName == 'group-panel' || src.groupName == 'group-cuando' || src.groupName == 'group-entonces';
      return true;
    },
    onDrop(arr, dropResult) {
      var self = this;
      console.log("ONDROPPP");
      applyDrag(arr, dropResult);
      self.$forceUpdate();
    },
    onDropOut: function(e) {
      const self = this;
      console.log("DROPPPPP");
      console.log(e);
      if (!self.readonly && !self.form.readonly) {
        self.loadFile(e);
      }
    },
    getValue: function() {
      const self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        context = context[namespaces[i]];
      }
      if (context && !Array.isArray(context)) {
        context = [context];
      }
      return context;
    },
    append: function(val) {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          if (
            typeof context[namespaces[i]] == "undefined" ||
            !context[namespaces[i]]
          )
            self.$set(context, namespaces[i], []);
          context[namespaces[i]].push(val);
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
    },
    deleteItem: function(index) {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      var doc = null;
 
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          if (
            typeof context[namespaces[i]] == "undefined" ||
            !context[namespaces[i]]
          ) {
            self.$set(context, namespaces[i], []);
          }
          if (context[namespaces[i]] && !Array.isArray(context[namespaces[i]])) {
              self.$delete(context, namespaces[i]);
          }  else {
              if (self.target == 'cordova') {
                if (context[namespaces]) {
                  doc = context[namespaces][index];
                } else if (context[namespaces[i]]) {
                  doc = context[namespaces[i]][index];
                }
              }
            self.$delete(context[namespaces[i]], index);
          }
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
      if (doc && doc.offlinePath && self.target == 'cordova') {
        FileUtils.deleteFile(doc.offlinePath,
          (a) => {
            console.log(a);
            },
          (e) => {
            console.log(e);
            }
          );
      }
    },
    /** Foto con la cámara (Cordova, formularios online): queda como un fichero cargado en web. */
    hacerFoto: function() {
      const self = this;
      const app = self.$f7;
      const value = self.getValue();
      if (self.maxFiles && (1 + (value ? value.length : 0)) > self.maxFiles) {
        app.dialog.alert("El número máximo de ficheros a añadir es " + self.maxFiles);
        return;
      }
      capturarFotoBase64()
        .then((foto) => {
          if (!foto) return;
          const fileLoaded = {
            nombre: foto.nombre,
            extension: foto.extension,
            path: self.path,
            conservarNombre: self.conservarNombre,
            sobrescribir: self.sobrescribir,
            _base64: foto._base64
          };
          self.append(fileLoaded);
          self.$emit("loadFile", fileLoaded);
          self.$emit("loadFiles", [fileLoaded]);
        })
        .catch((e) => app.dialog.alert(e && e.message ? e.message : "No se ha podido hacer la foto."));
    },
    loadFile: function(event) {
      var self = this;
      var app = self.$f7;
      let files = [];
      if (event instanceof FileList || Array.isArray(event)) {
        files = event;
      } else {
        files = event.target && event.target.files ? event.target.files : (event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : [])
      }
      var value = self.getValue();
      if (self.maxFiles && (files.length + (value && value != null ? value.length : 0)) > self.maxFiles) {
        app.dialog.alert("El número máximo de ficheros a añadir es " + self.maxFiles);
        self.$refs.input.value = "";
        return false;
      }
      var filesLoaded = [];
      var inputFilesLength = files.length;
      Array.from(files).forEach(file => {
        console.log("fileloaded", file);
        // Con ignorarOffline el fichero se trata como en la web (base64 que sube rForm al guardar)
        // también en la tablet: es lo que necesita un formulario que es online aunque corra en Cordova.
        if (self.target == 'cordova' && !self.ignorarOffline) {
          // const numFileName = (!value || !value.length ? 0 : Math.max(...value.map(d => d.nombre.indexOf("[") < 0 ? 0 : parseInt(d.nombre.split(']')[0].split('[').slice(-1).join() || "0", 10) || 0))) + 1;
          const timestamp = moment().format("YYYYMMDDHHmmss");
          self.documentoAdapter.saveBlob(file, self.offlineRootDir, `${self.offlinePath}/${timestamp}_${file.name}`)
            .then(({filePath,localURL}) => {
              var fileLoaded = {
                nombre: file.name.split(".").slice(0, -1).join("."),
                extension: /(?:\.([^.]+))?$/.exec(file.name)[1], //file.type.split("/")[1],
                _localURL: localURL,
                offlinePath: filePath
              };
              self.append(fileLoaded);
              filesLoaded.push(fileLoaded);
              app.preloader.hide();
              self.$emit("loadFile", fileLoaded);
              if (filesLoaded.length == inputFilesLength) {
                self.$emit("loadFiles", filesLoaded);
              }

            }).catch(e => {
              app.dialog.alert("Error guardando documento " + e);
              app.preloader.hide();
            })
        } else {
          var reader = new FileReader();
          reader.onload = function(e) {
            var fileLoaded = {
              nombre: file.name.split(".").slice(0, -1).join("."),
              extension: /(?:\.([^.]+))?$/.exec(file.name)[1], //file.type.split("/")[1],
              path: self.path,
              conservarNombre: self.conservarNombre,
              sobrescribir: self.sobrescribir,
              _base64: e.target.result
            };
            self.append(fileLoaded);
            filesLoaded.push(fileLoaded);
            app.preloader.hide();
            self.$emit("loadFile", fileLoaded);
            if (filesLoaded.length == inputFilesLength) {
              self.$emit("loadFiles", filesLoaded);
            }
          };
          reader.readAsDataURL(file);
        }
        app.preloader.show();
      });
      self.$refs.input.value = "";
    },
    getSrc(item) {
      var self = this;
      var app = self.$f7;
      switch (item.extension.toLowerCase()) {
        case "pdf":
          // Volvemos a usar el icono estático para PDFs
          return "static/rfiles/pdf.png";
          break;
        case "doc":
        case "docx":
          return "static/rfiles/doc.png";
          break;
        case "xls":
        case "xlsx":
          return "static/rfiles/xls.png";
          break;
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "webp":
        // HEIC/HEIF: la foto que deja la cámara cuando no se ha podido convertir a JPEG. Se trata
        // como imagen (miniatura escalada del servidor o su data URL) en vez de como adjunto genérico.
        case "heic":
        case "heif":
          if (item._scaledBase64) {
            return item._scaledBase64;
          } else if (!item._base64 && (self.target != 'cordova' || self.ignorarOffline)) {
            // Devolver getDocumentoScaledUrl para las miniaturas usando el endpoint público
            return self.documentoAdapter.getDocumentoScaledUrl(item);
          }
          // Con ignorarOffline el item lleva _base64 (ver loadFile), no offlinePath: se pinta como en la web.
          if (self.target == 'cordova' && !self.ignorarOffline) {
            if (!item._localURL) {
              window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, async function (fs) {
                fs.root.getFile(item.offlinePath, { create: false }, function (fileEntry) {
                  self.$set(item, '_localURL', fileEntry.nativeURL);
                });
              });
              return '';
            }
            return item._localURL;
          } else {
            return item._base64
              ? item._base64
              : "static/rfiles/attachment-icon.png" ;
          }
          break;
        case "mp4":
        case "mkv":
        case "vob":
        case "avi":
        case "mov":
          return "static/rfiles/video.png";
          break;
        case "m4a":
          return "static/rfiles/audio-icon.png";
          break;
        default:
          return "static/rfiles/attachment-icon.png";
      }
    },
    download(item) {
      var self = this;
      if (self.target == 'web' || self.ignorarOffline) {
        // Intentar usar la función de descarga del adaptador si está disponible
        try {
          if (self.documentoAdapter && typeof self.documentoAdapter.download === 'function') {
            self.documentoAdapter.download(item);
            return;
          }
        } catch (e) {
          console.error('Error usando adaptador de descarga:', e);
        }
        
        // Fallback: abrir URL en nueva pestaña
        try {
          if (self.documentoAdapter && typeof self.documentoAdapter.getDocumentoPublicUrl === 'function') {
            const url = self.documentoAdapter.getDocumentoPublicUrl(item);
            if (url) {
              window.open(url, "_blank");
              return;
            }
          }
        } catch (e) {
          console.error('Error obteniendo URL pública:', e);
        }
        
        console.warn('No se pudo descargar el documento');
      }
    },
    
    // Método para previsualizar un documento o descargarlo si no es posible previsualizarlo
    previewDocument(item, index) {
      var self = this;
      
      // La imagen que se pinte empieza ajustada: se suelta el zoom de la anterior (ver engancharZoom).
      self.soltarZoom();
      
      console.log('🔍 Preview:', item.nombre, {
        hasScaled: !!item._scaledBase64,
        hasBase64: !!item._base64
      });
      
      // Comprobar si el documento se puede previsualizar (imágenes y PDFs)
      const previewableExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif', 'pdf'];
      const extension = item.extension.toLowerCase();
      
      // Verificar que tengamos un adaptador de documento
      if (!self.documentoAdapter) {
        console.warn('documentoAdapter no disponible');
        return;
      }
      
      // Calcular el índice si no se proporciona
      if (typeof index === 'undefined') {
        const value = self.getValue();
        index = value ? value.indexOf(item) : -1;
      }
      
      // Inicializar propiedades del preview
      self.previewItem = item;
      self.previewIndex = index;
      self.previewModalVisible = true;
      
      // Verificar que las miniaturas se mantengan al abrir el modal
      self.ensureThumbnails();
      
      // Mostrar indicador de carga dentro del modal
      self.previewHtml = `<div class="rfiles-preview-loading"><span class="preloader"></span><div>Cargando...</div></div>`;
      self.$forceUpdate();
      
      if (previewableExtensions.includes(extension)) {
        try {
          if (extension === 'pdf') {
            // Para PDFs, descargar directamente por ahora
            if (typeof self.documentoAdapter.getDocumentoPublicUrl === 'function') {
              const url = self.documentoAdapter.getDocumentoPublicUrl(item);
              if (url) {
                self.closePreview();
                self.download(item);
              } else {
                self.closePreview();
                self.download(item);
              }
            } else {
              self.closePreview();
              self.download(item);
            }
          } else if (previewableExtensions.includes(extension)) {
            // Para imágenes, verificar si ya la tenemos en caché
            const cacheKey = `_previewBase64_${item.id || item.path}`;
            
            if (item._base64) {
              // Ya tenemos el base64 completo
              self.mostrarImagenPreview(item, item._base64);
            } else if (item[cacheKey]) {
              // Ya tenemos la imagen cacheada de una previsualización anterior
              // Con el mismo respaldo que la primera vez: los bytes cacheados pueden ser un HEIC que el WebView no pinta.
              self.mostrarImagenPreview(item, item[cacheKey]);
            } else if (item._scaledBase64) {
              // Tenemos una versión escalada - mostrarla inmediatamente y luego intentar mejorar
              self.previewHtml = `<div class="image-container"><img class="zoomable-image" src="${item._scaledBase64}" alt="${item.nombre}" /><div class="image-loading">Mejorando calidad...</div></div>`;
              self.$forceUpdate();
              
              // Intentar descargar la versión completa en segundo plano
              setTimeout(() => {
                self.downloadImageForPreview(item);
              }, 100);
            } else {
              // No tenemos ninguna versión - descargar directamente
              self.downloadImageForPreview(item);
            }
          }
        } catch (e) {
          console.error('❌ Error al previsualizar:', e);
          self.previewHtml = `<div class="rfiles-preview-error">Error al cargar el documento. <button class="button" @click="downloadFromPreview">Intentar descargar</button></div>`;
          self.$forceUpdate();
        }
      } else {
        // Documento no previsualizable - mostrar mensaje y opción de descarga
        self.previewHtml = `
          <div class="rfiles-preview-not-supported">
            <div class="rfiles-preview-icon">
              <f7-icon f7="doc"></f7-icon>
            </div>
            <div class="rfiles-preview-message">
              Este tipo de documento no se puede previsualizar.
            </div>
            <div class="rfiles-preview-actions-center">
              <f7-button @click="downloadFromPreview">Descargar archivo</f7-button>
            </div>
          </div>
        `;
        self.$forceUpdate();
      }
    },
    
    // Método para descargar una imagen y mostrarla en el preview
    downloadImageForPreview(item) {
      var self = this;
      
      if (!self.documentoAdapter || !self.previewItem) {
        return;
      }
      
      // Crear clave única para guardar en caché
      const cacheKey = `_previewBase64_${item.id || item.path}`;
      
      // Intentar primero getDocumento si está disponible
      if (typeof self.documentoAdapter.getDocumento === 'function') {
        self.documentoAdapter.getDocumento(item).then(data => {
          var blob = new Blob([data]);
          var reader = new FileReader();
          reader.onload = function(e) {
            const base64 = e.target.result;
            
            // Guardar en caché la imagen descargada para previsualización
            self.$set(item, cacheKey, base64);
            
            // Actualizar el preview con la imagen descargada solo si seguimos viendo este item
            if (self.previewItem && self.previewItem === item) {
              // Reemplazar completamente el HTML para quitar el mensaje de carga
              self.mostrarImagenPreview(item, base64);
              
              // Verificar que las miniaturas se mantengan después de actualizar el preview
              self.ensureThumbnails();
            }
          };
          reader.readAsDataURL(blob);
        }).catch(e => {
          console.error('❌ Error descargando imagen:', e);
          // Si hay error, intentar usar URL pública como fallback
          self.usePublicUrlForPreview(item);
        });
      } else {
        // Si no está disponible getDocumento, usar URL pública
        self.usePublicUrlForPreview(item);
      }
    },
    
    /**
     * Pinta una imagen en la previsualización con respaldo: si el WebView no sabe decodificarla
     * (un HEIC descargado tal cual), se cambia a la miniatura escalada que sirve el servidor en vez
     * de dejar una imagen rota; y si tampoco, el aviso de error.
     */
    mostrarImagenPreview(item, src) {
      var self = this;
      self.previewHtml = `<div class="image-container"><img class="zoomable-image" src="${src}" alt="${item.nombre}" /></div>`;
      self.$forceUpdate();
      self.$nextTick(function() {
        var img = document.querySelector('.rfiles-preview-popup .rfiles-preview-doc img.zoomable-image');
        if (!img) return;
        img.onerror = function() {
          if (self.previewItem !== item) return;
          var respaldo = item._scaledBase64
            || (item.path && self.documentoAdapter && typeof self.documentoAdapter.getDocumentoScaledUrl === 'function'
              ? self.documentoAdapter.getDocumentoScaledUrl(item) : null);
          var error = function() {
            if (self.previewItem !== item) return;
            self.previewHtml = `<div class="rfiles-preview-error">No se pudo cargar la imagen. <button class="button" @click="downloadFromPreview">Intentar descargar</button></div>`;
            self.$forceUpdate();
          };
          if (respaldo && img.getAttribute('src') !== respaldo) {
            img.onerror = error;
            img.src = respaldo;
          } else {
            error();
          }
        };
      });
    },

    // Método de fallback para usar la URL pública
    usePublicUrlForPreview(item) {
      var self = this;
      if (typeof self.documentoAdapter.getDocumentoPublicUrl === 'function') {
        try {
          const url = self.documentoAdapter.getDocumentoPublicUrl(item);
          if (url && self.previewItem === item) {
            // Crear un manejador de errores para la imagen
            const img = new Image();
            img.onload = function() {
              // Si la imagen se carga correctamente, mostrarla
              self.previewHtml = `<div class="image-container"><img class="zoomable-image" src="${url}" alt="${item.nombre}" /></div>`;
              self.$forceUpdate();
            };
            img.onerror = function() {
              // Si hay error cargando la URL pública, mostrar la miniatura si está disponible
              console.error('Error cargando imagen desde URL pública');
              if (item._scaledBase64 && self.previewItem === item) {
                self.previewHtml = `<div class="image-container"><img class="zoomable-image" src="${item._scaledBase64}" alt="${item.nombre}" /></div>`;
                self.$forceUpdate();
              } else {
                // Si no hay miniatura, mostrar error
                self.previewHtml = `<div class="rfiles-preview-error">No se pudo cargar la imagen. <button class="button" @click="downloadFromPreview">Intentar descargar</button></div>`;
                self.$forceUpdate();
              }
            };
            img.src = url;
          } else {
            // Si no se pudo obtener la URL, mostrar miniatura o error
            if (item._scaledBase64 && self.previewItem === item) {
              self.previewHtml = `<div class="image-container"><img class="zoomable-image" src="${item._scaledBase64}" alt="${item.nombre}" /></div>`;
              self.$forceUpdate();
            } else {
              self.previewHtml = `<div class="rfiles-preview-error">No se pudo cargar la imagen. <button class="button" @click="downloadFromPreview">Intentar descargar</button></div>`;
              self.$forceUpdate();
            }
          }
        } catch (e) {
          console.error('Error usando URL pública para preview:', e);
          // Mostrar miniatura como fallback si hay error
          if (item._scaledBase64 && self.previewItem === item) {
            self.previewHtml = `<div class="image-container"><img class="zoomable-image" src="${item._scaledBase64}" alt="${item.nombre}" /></div>`;
            self.$forceUpdate();
          } else {
            self.previewHtml = `<div class="rfiles-preview-error">Error al cargar la imagen. <button class="button" @click="downloadFromPreview">Intentar descargar</button></div>`;
            self.$forceUpdate();
          }
        }
      } else {
        // Si no hay adaptador disponible, mostrar miniatura o error
        if (item._scaledBase64 && self.previewItem === item) {
          self.previewHtml = `<div class="image-container"><img class="zoomable-image" src="${item._scaledBase64}" alt="${item.nombre}" /></div>`;
          self.$forceUpdate();
        } else {
          self.previewHtml = `<div class="rfiles-preview-error">No se pudo cargar la imagen. <button class="button" @click="downloadFromPreview">Intentar descargar</button></div>`;
          self.$forceUpdate();
        }
      }
    },
    
    closePreview() {
      var self = this;
      console.log('🔄 Inicializando visor PDF:', url);
      
      // Limpiar estado anterior del PDF
      self.pdfSrc = null;
      self.pdfCurrentPage = 1;
      self.pdfTotalPages = 0;
      self.pdfScale = 1.0;
      self.pdfLoading = true;
      self.pdfError = null;
      
      // Limpiar contenido HTML ya que ahora usaremos el componente vue-pdf
      self.previewHtml = '';
      
      // Configurar la fuente del PDF
      self.pdfSrc = url;
      
      self.$forceUpdate();
    },
    
    onPdfLoaded(event) {
      var self = this;
      console.log('✅ PDF cargado:', event);
      // Con iframe, no tenemos información detallada de páginas
      self.pdfLoading = false;
      self.pdfError = null;
      self.$forceUpdate();
    },
    
    onPdfPageLoaded(page) {
      console.log('✅ Página PDF cargada:', page);
    },
    
    onPdfIframeLoad() {
      var self = this;
      console.log('✅ Iframe PDF cargado');
      self.pdfLoading = false;
      self.pdfError = null;
      self.$forceUpdate();
    },
    
    onPdfIframeError() {
      var self = this;
      console.error('❌ Error cargando iframe PDF');
      self.pdfLoading = false;
      self.pdfError = 'Error al cargar el PDF en el visor';
      self.$forceUpdate();
    },
    
    onPdfError(error) {
      var self = this;
      console.error('❌ Error cargando PDF:', error);
      self.pdfLoading = false;
      self.pdfError = 'Error al cargar el PDF';
      self.$forceUpdate();
    },
    
    openPdfInNewTab() {
      var self = this;
      if (self.pdfSrc) {
        window.open(self.pdfSrc, "_blank");
      }
    },
    
    closePreview() {
      var self = this;
      
      // Verificar que las miniaturas se mantengan después de cerrar el modal
      var value = self.getValue();
      if (value) {
        var thumbnailsLost = 0;
        value.forEach(item => {
          if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif'].includes(item.extension.toLowerCase()) && !item._scaledBase64) {
            thumbnailsLost++;
          }
        });
        if (thumbnailsLost > 0) {
          console.warn(`⚠️ ${thumbnailsLost} miniaturas perdidas al cerrar preview`);
          self.ensureThumbnails();
        }
      }
      
      // Ocultar popup
      self.previewModalVisible = false;
      // Limpiar referencias
      self.previewItem = null;
      self.previewIndex = -1;
      self.previewHtml = '';
      self.soltarZoom();
      // Limpiar variables del PDF
      self.pdfSrc = null;
      self.pdfCurrentPage = 1;
      self.pdfTotalPages = 0;
      self.pdfScale = 1.0;
      self.pdfLoading = false;
      self.pdfError = null;
      // Forzar actualización para asegurar que se liberan recursos
      self.$nextTick(() => {
        self.$forceUpdate();
      });
    },
    
    // Método para verificar y restaurar miniaturas si se pierden
    ensureThumbnails: function() {
      var self = this;
      
      var value = self.getValue();
      if (value && self.documentoAdapter && typeof self.documentoAdapter.getDocumentoScaledUrl === 'function') {
        var needsUpdate = false;
        value.forEach(item => {
          // Solo para imágenes que no tienen miniatura pero deberían tenerla
          if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif'].includes(item.extension.toLowerCase()) && 
              self.target != 'cordova' && !item._base64 && !item._scaledBase64) {
            
            var scaledUrl = self.documentoAdapter.getDocumentoScaledUrl(item);
            if (scaledUrl) {
              var img = new Image();
              // Configurar CORS para evitar problemas
              img.crossOrigin = 'anonymous';
              img.onload = function() {
                try {
                  // Validar que la imagen tenga dimensiones válidas
                  if (img.width === 0 || img.height === 0) {
                    console.warn(`⚠️ Imagen sin dimensiones válidas: ${item.nombre}`);
                    return;
                  }
                  
                  var canvas = document.createElement('canvas');
                  var ctx = canvas.getContext('2d');
                  canvas.width = img.width;
                  canvas.height = img.height;
                  
                // Intentar dibujar la imagen en el canvas
                ctx.drawImage(img, 0, 0);
                
                // Intentar obtener el base64 con manejo de errores
                var scaledBase64;
                try {
                  scaledBase64 = canvas.toDataURL('image/jpeg', 0.8);
                } catch (corsError) {
                  // Si hay error de CORS, intentar con formato PNG
                  try {
                    scaledBase64 = canvas.toDataURL('image/png');
                  } catch (pngError) {
                    console.error(`❌ Error CORS al generar base64 para ${item.nombre}:`, corsError);
                    return;
                  }
                }                  // Validar que el base64 no esté vacío
                  if (scaledBase64 && scaledBase64.length > 100) {
                    self.$set(item, '_scaledBase64', scaledBase64);
                    self.$forceUpdate();
                  } else {
                    console.warn(`⚠️ Base64 inválido generado para: ${item.nombre}`);
                  }
                } catch (e) {
                  console.error(`❌ Error procesando miniatura para ${item.nombre}:`, e);
                }
              };
              img.onerror = function() {
                console.warn(`❌ Error cargando miniatura: ${item.nombre}`);
              };
              img.src = scaledUrl;
              needsUpdate = true;
            }
          }
        });
        
        if (needsUpdate) {
          console.log('🔄 Restaurando miniaturas perdidas...');
        }
      }
    },
    
    downloadFromPreview() {
      var self = this;
      if (self.previewItem) {
        // Guardar una referencia al item que queremos descargar
        const itemToDownload = self.previewItem;
        
        // Mostrar indicador de descarga
        if (self.$f7 && self.$f7.toast) {
          self.$f7.toast.create({
            text: 'Preparando descarga...',
            position: 'center',
            closeTimeout: 2000,
          }).open();
        }
        
        // Cerrar el popup primero
        self.previewModalVisible = false;
        
        // Usar setTimeout para dar tiempo al popup a cerrarse
        setTimeout(() => {
          // Intentar descarga usando el método del adaptador
          if (self.documentoAdapter && typeof self.documentoAdapter.download === 'function') {
            try {
              self.documentoAdapter.download(itemToDownload);
              self.documentoAdapter.download(itemToDownload);
            } catch (e) {
              console.error('Error en descarga del adaptador:', e);
              // Fallback: abrir URL en nueva pestaña
              self.fallbackDownload(itemToDownload);
            }
          } else {
            // Fallback directo
            self.fallbackDownload(itemToDownload);
          }
        }, 300);
      }
    },
    
    downloadZipFromPreview() {
      var self = this;
      // Mostrar indicador de descarga
      if (self.$f7 && self.$f7.toast) {
        self.$f7.toast.create({
          text: 'Preparando descarga...',
          position: 'center',
          closeTimeout: 2000,
        }).open();
      }
      
      // Cerrar el popup primero
      self.previewModalVisible = false;
      
      // Usar setTimeout para dar tiempo al popup a cerrarse
      setTimeout(() => {
        // Intentar descarga usando el método del adaptador
        if (self.documentoAdapter && typeof self.documentoAdapter.downloadZip === 'function') {
          try {
            self.documentoAdapter.downloadZip(self.form.formData[self.name]);
          } catch (e) {
            console.error('Error en descarga del adaptador:', e);
            // Fallback: abrir URL en nueva pestaña
            self.fallbackDownload(self.form.formData[self.name]);
          }
        } else {
          // Fallback directo
          self.fallbackDownload(self.form.formData[self.name]);
        }
      }, 300);
    },
    
    fallbackDownload(item) {
      var self = this;
      try {
        if (self.documentoAdapter && typeof self.documentoAdapter.getDocumentoPublicUrl === 'function') {
          const url = self.documentoAdapter.getDocumentoPublicUrl(item);
          if (url) {
            window.open(url, "_blank");
            return;
          }
        }
      } catch (e) {
        console.error('Error obteniendo URL pública:', e);
      }
      
      console.warn('No se pudo descargar el documento');
      if (self.$f7 && self.$f7.toast) {
        self.$f7.toast.create({
          text: 'Error al descargar el archivo',
          position: 'center',
          closeTimeout: 3000,
        }).open();
      }
    },
    see(item) {
      var self = this;
      if (item._localURL) {
          if (['jpg', 'jpeg', 'png', 'gif'].includes(item.extension)) {
            PhotoViewer.show(item._localURL);
          } else if (['mp4', 'mkv', 'vob', 'avi', 'mov'].includes(item.extension)) {
            VideoPlayer.play(item._localURL);
          } else if (['m4a', 'wma', 'mp3'].includes(item.extension)) {
            var media = new Media(item._localURL);
            media.play();
          } else {
            cordova.plugins.fileOpener2.open(item._localURL, item._type, {onError, success : function(){ console.log("Abierto") }});
          }
      } else if (item.offlinePath){
        var onError = function (e) {
          console.log("ERROR");
          console.log(e);
        }
        window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, async function (fs) {
          fs.root.getFile(item.offlinePath, { create: false }, function (fileEntry) {
            item._localURL = fileEntry.nativeURL || 'MALO';
            self.see(item);
          }, onError);
        }, onError);
      } 
    },
    
    // Método para limpiar la caché de preview (útil para liberar memoria)
    clearPreviewCache() {
      var self = this;
      var value = self.getValue();
      if (value) {
        value.forEach(item => {
          const cacheKey = `_previewBase64_${item.id || item.path}`;
          if (item[cacheKey]) {
            self.$delete(item, cacheKey);
          }
        });
        console.log('🧹 Caché de preview limpiada');
      }
    },
    
    /**
     * Engancha el zoom (rueda, pellizco, arrastre y doble toque; ver js/utils/zoomImagen.js) a la
     * imagen de la previsualización. La imagen la inyecta previewHtml, así que se llama desde
     * updated(): no hace nada mientras siga siendo el mismo <img>, y si es otro (otra imagen, o la
     * misma ya en calidad completa) suelta el anterior y engancha el nuevo.
     *
     * Se busca SOLO dentro del popup de esta instancia (por ref, que vale aunque Framework7 lo
     * mueva de sitio): en una pantalla con varios rFiles (p. ej. Elemento.vue), un repintado de
     * otro no debe encontrar la imagen de este y montarle un segundo controlador.
     */
    engancharZoom() {
      const self = this;
      const popup = self.$refs.previewPopup && self.$refs.previewPopup.$el;
      const img = popup && popup.querySelector
        ? popup.querySelector('.rfiles-preview-doc .image-container img.zoomable-image')
        : null;
      if (self._zoomImagen && self._zoomImagen.img === img) return;
      self.soltarZoom();
      if (!img) return;
      self._zoomImagen = { img: img, zoom: zoomImagen(img) };
    },

    soltarZoom() {
      if (this._zoomImagen) {
        this._zoomImagen.zoom.destruir();
        this._zoomImagen = null;
      }
    }
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    
    
    // Cargar thumbnails para imágenes usando URLs públicas
    self.loadingThumbnails = true;
    var value = self.getValue();
    if (value && self.documentoAdapter && typeof self.documentoAdapter.getDocumentoScaledUrl === 'function') {
      console.log(`📷 Cargando ${value.length} miniaturas...`);
      
      value.forEach((item, index) => {
        // Cargar thumbnails solo para imágenes (no para PDFs)
        if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif'].includes(item.extension.toLowerCase()) && 
            self.target != 'cordova' && !item._base64 && !item._scaledBase64) {
          
          // Usar la URL de miniatura para precargar
          var scaledUrl = self.documentoAdapter.getDocumentoScaledUrl(item);
          if (scaledUrl) {
            var img = new Image();
            // Configurar CORS para evitar problemas
            img.crossOrigin = 'anonymous';
            img.onload = function() {
              try {
                // Validar que la imagen tenga dimensiones válidas
                if (img.width === 0 || img.height === 0) {
                  console.warn(`⚠️ Imagen sin dimensiones válidas: ${item.nombre}`);
                  return;
                }
                
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                
                // Intentar dibujar la imagen en el canvas
                ctx.drawImage(img, 0, 0);
                
                // Intentar obtener el base64 con manejo de errores
                var scaledBase64;
                try {
                  scaledBase64 = canvas.toDataURL('image/jpeg', 0.8);
                } catch (corsError) {
                  // Si hay error de CORS, intentar con formato PNG
                  try {
                    scaledBase64 = canvas.toDataURL('image/png');
                  } catch (pngError) {
                    console.error(`❌ Error CORS al generar base64 para ${item.nombre}:`, corsError);
                    return;
                  }
                }
                
                // Validar que el base64 no esté vacío
                if (scaledBase64 && scaledBase64.length > 100) {
                  self.$set(item, '_scaledBase64', scaledBase64);
                  self.$forceUpdate();
                } else {
                  console.warn(`⚠️ Base64 inválido generado para: ${item.nombre}`);
                }
              } catch (e) {
                console.error(`❌ Error procesando miniatura para ${item.nombre}:`, e);
              }
            };
            img.onerror = function() {
              console.warn(`❌ Error cargando miniatura: ${item.nombre}`);
            };
            img.src = scaledUrl;
          }
        }
      });
    }
    self.loadingThumbnails = false;
  },
  
  updated() {
    // La imagen de la previsualización la inyecta previewHtml: al repintar se le engancha el zoom.
    this.engancharZoom();
  },

  beforeDestroy() {
    this.soltarZoom();
  }
};
</script>
<style>
.rfiles .rfiles-container {
  min-height: 50px;
  display: flex !important;
  width: 100%;
  overflow-x: auto;
}
.rfiles .rfiles-container.dashed {
  border: 2px dashed black;
}
.rfiles .rfiles-origin-wrapper {
  width: 100%;
}
.rfiles .rfiles-origin-title {
  font-size: 12px;
  font-weight: 600;
  color: #2e4c77;
  margin: 4px 0;
}
.rfiles .rfiles-origin-fieldset {
  border: 2px solid #f2b94b;
  border-radius: 8px;
  padding: 8px;
  margin-top: 8px;
}
.rfiles .rfiles-origin-fieldset legend {
  font-size: 12px;
  font-weight: 600;
  color: #8a5a00;
  padding: 0 6px;
}
.rfiles .rfiles-origin-fieldset legend .badge {
  font-size: 12px;
  font-weight: 600;
  background-color: #8a5a00;
  padding: 0 6px;
}
.rfiles-item {
  cursor: pointer;
  position: relative;
  margin: 3px;
}
.rfiles-item a {
  display: block;
}
.rfiles-close {
  position: absolute;
  right: 2px;
  top: 0;
  background: white;
  border-radius: 50%;
}

/* li.comentario-rfile {
  list-style: none;
} */

li.comentario-rfile div.item-title {
  position: relative;
  left: 6px;
  border-radius: 5px;
  font-size: 10px;
}
.rfiles-item {
  border: 1px dashed #e0e9d9;
  background-color: white;
  border-radius: 5px;
}
.rfiles-badge {
  position: absolute;
  top: 3px;
  right: 23px;
  z-index: 100;
  opacity: 0.7;
}
.rfiles-check {
  position: absolute;
  top: 3px;
  left: 3px;
  z-index: 100;
  background: #ffffff86;
}
li.comentario-rfile div.item-input-wrap, li.comentario-rfile div.item-input, li.comentario-rfile div.item-input-wrap textarea {
  width: 100%;
}
li.comentario-rfile div.item-content, li.comentario-rfile div.item-inner {
  padding: 0;
}
li.comentario-rfile div.item-inner {
  width: 100%;
}
li.comentario-rfile div.item-input-wrap textarea {
  width: 100%;
  height: 50px !important; 
  background-color: #e0e9d9;
  border: none;
} 
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

/* Botones de añadir: archivo y, en la APK, cámara. */
.rfiles-add { display: flex; gap: 8px; flex-wrap: wrap; }
.rfiles-add .button { flex: 1 1 auto; }

/* Estilos para el popup de previsualización */
.rfiles-preview-popup .page {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 !important;
  margin: 0 !important;
}

.rfiles-preview-popup .page > * {
  margin: 0;
}

.rfiles-preview-popup .navbar {
  /* F7 pone `.page > .navbar` en absoluto, flotando sobre el contenido; aquí la página es una
     columna flex, así que la barra entra en el flujo y el contenido empieza DEBAJO de ella (antes
     el principio de la imagen quedaba tapado por el título). */
  position: relative;
  flex-shrink: 0;
  padding: 0 16px;
}
/* Sin backdrop el popup necesita su propio borde y sombra para distinguirse del fondo. */
.rfiles-preview-popup {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  border: 1px solid #cfd8dc;
}
.rfiles-preview-popup.popup-arrastrando {
  user-select: none;
  opacity: 0.92;
}

.rfiles-preview-popup .page-content {
  flex: 1;
  overflow: hidden;
  padding: 0;
  margin: 0;
  /* La altura la da el flex (todo menos la barra); con 100% se salía por abajo lo que mide la barra. */
  height: auto;
  min-height: 0;
}

.rfiles-preview-content {
  padding: 0 !important;
  margin: 0 !important;
  flex-grow: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  /* flex-start y no center: una caja centrada que desborda se recorta por los dos lados y el
     principio queda inalcanzable. El centrado lo hace el margin:auto del hijo cuando cabe. */
  align-items: flex-start;
  width: 100%;
  height: 100%;
  position: relative;
  min-height: 0;
  z-index: 1000;
}
/* El div que inyecta previewHtml: sin altura propia, el max-height de la imagen no tenía a qué
   referirse y la imagen salía a su tamaño natural, más alta que el área. Solo ese div: las flechas
   y el contador son también hijos directos del bloque y no deben estirarse. */
.rfiles-preview-content > .rfiles-preview-doc {
  width: 100%;
  height: 100%;
  min-height: 0;
  margin: auto;
}

/* Estilos para elementos dentro del contenido del preview */
.rfiles-preview-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px;
}

.rfiles-preview-error {
  text-align: center;
  padding: 20px;
  color: #f44336;
}

.rfiles-preview-not-supported {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 40px;
}

.rfiles-preview-icon {
  font-size: 60px;
  opacity: 0.7;
}

.rfiles-preview-message {
  font-size: 16px;
  text-align: center;
  color: #666;
}

.rfiles-preview-actions-center {
  margin-top: 20px;
}

/* Contenedor de imágenes */
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  /* La imagen ampliada se recorta aquí y se recorre arrastrándola (zoomImagen). */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: auto;
}

.image-container img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transform-origin: center center;
  display: block;
  flex-shrink: 0;
}

.image-container img.zoomable-image {
  cursor: zoom-in;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
}

.image-loading {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgba(0,0,0,0.5);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
}

/* Contenedor de PDF */
.pdf-container {
  width: 100%;
  height: 100%;
  min-height: 70vh;
  position: relative;
}

/* Estilos para el visor de PDF con object */
.pdf-preview-container {
  width: 100%;
  height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pdf-preview-object {
  width: 100%;
  height: 100%;
  min-height: 60vh;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f5f5f5;
}

.pdf-preview-iframe {
  width: 100%;
  height: 100%;
  min-height: 65vh;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f5f5f5;
}

.pdf-preview-actions {
  margin-top: 15px;
  text-align: center;
}

.pdf-preview-actions .button {
  display: inline-block;
  padding: 8px 20px;
  border: 2px solid var(--f7-theme-color, #2196f3);
  color: var(--f7-theme-color, #2196f3);
  text-decoration: none;
  border-radius: 4px;
  font-size: 14px;
  background: transparent;
}

.pdf-preview-actions .button:hover {
  background-color: var(--f7-theme-color, #2196f3);
  color: white;
}

.pdf-preview-not-supported {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
  min-height: 300px;
}

.pdf-preview-not-supported .pdf-preview-icon {
  font-size: 80px;
  color: #999;
  margin-bottom: 20px;
}

.pdf-preview-not-supported .pdf-preview-icon i {
  font-size: 80px;
}

.pdf-preview-not-supported p {
  font-size: 16px;
  color: #666;
  margin: 0 0 20px 0;
}

.pdf-download-btn {
  display: inline-block;
  padding: 12px 24px;
  background-color: var(--f7-theme-color, #2196f3);
  color: white !important;
  text-decoration: none;
  border-radius: 6px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.pdf-download-btn:hover {
  opacity: 0.9;
}

.pdf-preview-fallback {
  margin-top: 15px;
  text-align: center;
  font-size: 13px;
  color: #666;
}

.pdf-preview-fallback p {
  margin: 0 0 10px 0;
}

.pdf-preview-fallback .button {
  display: inline-block;
  padding: 8px 16px;
  background-color: var(--f7-theme-color, #2196f3);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 14px;
}

.pdf-preview-fallback .button:hover {
  opacity: 0.9;
}

.pdf-hint {
  text-align: center;
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

/* Estilos para el visor de PDF con iframe */
.pdf-controls {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 0;
}

.pdf-controls .block {
  margin: 0;
  padding: 10px 15px;
}

.pdf-info {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  height: 32px;
}

.pdf-viewer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  background-color: #f5f5f5;
  padding: 0;
  width: 100%;
}

.pdf-iframe {
  width: 100%;
  height: 70vh;
  border: none;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

/* Responsive para controles de PDF */
@media (max-width: 768px) {
  .pdf-controls .row .col {
    text-align: center;
  }
  
  .pdf-controls .button {
    font-size: 12px;
    min-width: auto;
    padding: 5px 8px;
  }
  
  .pdf-iframe {
    height: 60vh;
  }
}

/* Mejoras para el loading y error del PDF */
.rfiles-preview-loading,
.rfiles-preview-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 40px;
  text-align: center;
}

.rfiles-preview-loading .preloader {
  margin-bottom: 10px;
}

/* Estilos para las flechas de navegación del preview */
.rfiles-preview-nav {
  position: absolute;
  top: 10px;
  bottom: 20px;
  z-index: 1001;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  background: rgba(255, 255, 255, 0.15);
  opacity: 0.7;
  transition: opacity 0.3s, background 0.3s;
  backdrop-filter: blur(2px);
  pointer-events: auto;
}

.rfiles-preview-nav i,
.rfiles-preview-nav .f7-icons {
  font-size: 60px;
  color: rgba(0, 0, 0, 0.35);
  transition: color 0.3s, transform 0.2s;
}

.rfiles-preview-nav:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.4);
}

.rfiles-preview-nav:hover i,
.rfiles-preview-nav:hover .f7-icons {
  color: rgba(0, 0, 0, 0.6);
  transform: scale(1.05);
}

.rfiles-preview-nav-prev {
  left: 0;
  border-radius: 0 8px 8px 0;
}

.rfiles-preview-nav-next {
  right: 0;
  border-radius: 8px 0 0 8px;
}

.rfiles-preview-counter {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 500;
  z-index: 100;
}

/* Hacer el contenedor del preview relativo para posicionar las flechas */
.rfiles-preview-content {
  position: relative;
}

/* Ajustes responsive para las flechas */
@media (max-width: 768px) {
  .rfiles-preview-nav {
    width: 50px;
  }
  
  .rfiles-preview-nav i,
  .rfiles-preview-nav .f7-icons {
    font-size: 50px;
  }
  
  .rfiles-preview-counter {
    font-size: 12px;
    padding: 4px 12px;
  }
}
</style>
